/**
 * Hook to get the effective branch ID based on user role
 *
 * For SUPER_ADMIN: Returns selectedBranchId (from branch selector dropdown)
 * For regular users: Returns user.branchId (their assigned branch)
 *
 * This ensures that regular users always see data filtered by their assigned branch,
 * while super admins can switch between branches using the selector.
 */

import { useMemo } from "react";
import { selectAuthAdmin, useAuthStore } from "../store/useAuth";
import { useBranchContext } from "../context/useBranchContext";

export const useEffectiveBranchId = (): string | null => {
  const user = useAuthStore(selectAuthAdmin);
  const { selectedBranchId } = useBranchContext();

  return useMemo(() => {
    // If user is super admin, use the selected branch from dropdown
    if ((user?.role === "SUPER_ADMIN" || user?.role === "MULTI_BRANCH_ADMIN")) {
      return selectedBranchId;
    }

    // For regular users, always use their assigned branchId
    return user?.branchId || null;
  }, [user?.role, user?.branchId, selectedBranchId]);
};
